import axios from "axios";
import { stripeConfig, ucEndpointsUrls } from "../config/config";

/**
 * Create Stripe checkout session from UC's API.
 *
 * @param {Array<Object>} items       - Stripe items.
 * @param {String} successUrl         - URL to redirect after success.
 * @param {String} cancelUrl          - URL to redirect after cancel.
 * @param {Boolean} isSubscription    - Is the checkout session including subscriptions?.
 * @return {Promise<any>}             - Resolves with CheckoutSession or rejects with error.
 */
export const createUcCheckoutSession = (items, successUrl, cancelUrl, isSubscription = true) => {
  return new Promise((resolve, reject) => {
    axios
      .post(ucEndpointsUrls.stripeCheckoutSession, {
        items: items,
        successUrl: successUrl,
        cancelUrl: cancelUrl,
        subscription: isSubscription
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};

/**
 * Creates a Checkout Session from backend &
 * redirects user to Stripe Checkout.
 *
 * @param {String} stripeId               - Stripe subscriptions ID.
 * @return {Promise}                      - Rejects with error.
 */
export const addStripeSubscription = stripeId => {
  // eslint-disable-next-line no-undef
  const stripe = new Stripe(stripeConfig.publicKey);
  return new Promise((resolve, reject) => {
    createUcCheckoutSession([{ plan: stripeId }], stripeConfig.successUrl, stripeConfig.cancelUrl)
      .then(checkoutSession => {
        return stripe.redirectToCheckout({
          sessionId: checkoutSession.id
        });
      })
      .then(result => {
        if (result.error) {
          return reject(result.error);
        }
        return reject(result);
      })
      .catch(err => reject(err));
  });
};

/**
 * Creates a Checkout Session from backend &
 * redirects user to Stripe Checkout.
 *
 * @param {String} stripeSkuId            - Stripe Sku ID.
 * @param {Number} quantity               - Quantity of products.
 * @param {String} email                  - User email.
 * @param {Number} userId                 - User ID.
 * @return {Promise}                      - Rejects with error.
 */
export const addStripeProduct = (stripeSkuId, quantity, email, userId) => {
  // eslint-disable-next-line no-undef
  const stripe = new Stripe(stripeConfig.publicKey);
  return new Promise((resolve, reject) => {
    const options = {
      items: [{ sku: stripeSkuId, quantity: parseInt(quantity) }],
      successUrl: stripeConfig.successUrl,
      cancelUrl: stripeConfig.cancelUrl,
      customerEmail: email,
      clientReferenceId: userId
    };
    stripe
      .redirectToCheckout(options)
      .then(result => {
        if (result.error) {
          return reject(result.error);
        }
        return reject(result);
      })
      .catch(err => reject(err));
  });
};
